/* eslint-disable no-unused-vars */
import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Icon from '@chama/ui-components/components/Icon';

import './MapControls.css';

const variables = require('@chama/statics/stylesheets/variables').default;

const createButton = (type, onClick, active, enabled = true) => {
  const color = active ? variables['--chama-blue'] : variables['--scorpion'];
  return (
    <Icon
      className="MapControls__button"
      width={24}
      height={24}
      iconColor={enabled ? color : variables['--mystic']}
      type={type}
      onClick={onClick}
    />
  );
};

export default class Controls extends React.Component {
  state = { isVisible: false };

  componentDidMount() {
    setTimeout(() => {
      this.setState({ isVisible: true });
    }, 100);
  }

  render() {
    const {
      activeControls,
      undoEnabled,
      onUndoClick,
      redoEnabled,
      onRedoClick,
      onEditClick,
      onToggleMapView,
      isFullScreenView,
    } = this.props;

    const { isVisible } = this.state;

    const { editPolygonMode } = activeControls;

    return (
      <div className={classnames('MapControls', { 'MapControls--visible ': isVisible })}>
        <div className="MapControls__container">
          {createButton(
            isFullScreenView ? 'disableFullscreen' : 'enableFullscreen',
            onToggleMapView,
            false,
          )}
        </div>
        <div className="MapControls__container">
          {createButton('undo', onUndoClick, false, undoEnabled)}
          {createButton('redo', onRedoClick, false, redoEnabled)}
          {createButton('editPolygon', onEditClick, editPolygonMode)}
        </div>
      </div>
    );
  }
}
Controls.propTypes = {
  activeControls: PropTypes.object.isRequired,
  undoEnabled: PropTypes.bool.isRequired,
  onUndoClick: PropTypes.func,
  redoEnabled: PropTypes.bool.isRequired,
  onRedoClick: PropTypes.func,
  onEditClick: PropTypes.func,
  onToggleMapView: PropTypes.func.isRequired,
  isFullScreenView: PropTypes.bool.isRequired,
};
Controls.defaultProps = {
  onUndoClick: Function.prototype,
  onRedoClick: Function.prototype,
  onEditClick: Function.prototype,
};



// WEBPACK FOOTER //
// ../ui-components/components/CoverageAreaMap/components/MapControls/MapControls.jsx